import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { FailedMethodsSection } from '../components/FailedMethodsSection';
import { AchievementsSection } from '../components/AchievementsSection';
import { StepsSection } from '../components/StepsSection';
import { DifferenceSection } from '../components/DifferenceSection';
import { PricingSection } from '../components/PricingSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { FinalCTASection } from '../components/FinalCTASection';
import { Footer } from '../components/Footer';
import { RecentPurchaseToast } from '../components/RecentPurchaseToast';
function Divider() {
  return <div className="w-full h-px bg-gradient-to-r from-transparent via-gold/30 to-transparent" data-id="element-305"></div>;
}
export function LandingPage() {
  return <main className="min-h-screen bg-navy-900 text-gray-200 font-sans selection:bg-gold selection:text-navy-900" data-id="element-306">
      <HeroSection data-id="element-307" />
      <Divider data-id="element-308" />
      <ProblemSection data-id="element-309" />
      <Divider data-id="element-310" />
      <FailedMethodsSection data-id="element-311" />
      <Divider data-id="element-312" />
      <AchievementsSection data-id="element-313" />
      <Divider data-id="element-314" />
      <StepsSection data-id="element-315" />
      <Divider data-id="element-316" />
      <DifferenceSection data-id="element-317" />
      <Divider data-id="element-318" />
      <PricingSection data-id="element-319" />
      <Divider data-id="element-320" />
      <GuaranteeSection data-id="element-321" />
      <Divider data-id="element-322" />
      <FinalCTASection data-id="element-323" />
      <Footer data-id="element-324" />
      <RecentPurchaseToast data-id="element-325" />
    </main>;
}